
/**
 * !!! Adapted !!!
 * Returns the amount of pixels for any unit (for e.g. em, rem, etc...)
 */
// https://stackoverflow.com/questions/10463518/converting-em-to-px-in-javascript-and-getting-default-font-size
const getComputedSizeToPixel = ({ cssValue = '1em', parent = document.body, axis = 'y' } = {}) => {
	const tempEl = document.createElement('div');
	tempEl.style.visibility = 'hidden';
	tempEl.style.boxSize = 'content-box';
	tempEl.style.position = 'absolute';
	tempEl.style.maxHeight = 'none';
	tempEl.style.maxWidth = 'none';
	
	if (axis === 'x') {
		tempEl.style.width = cssValue;
	} else if (axis === 'y') {
		tempEl.style.height = cssValue;
	}
	parent.appendChild(tempEl);
	let result;
	
	if (axis === 'x') {
		result = tempEl.clientWidth;
	} else if (axis === 'y') {
		result = tempEl.clientHeight;
	}
	tempEl.remove();
	return result;
};



/*
	extraOffset = {
		left: any number value from 0 - 1,
		top: any number value from 0 - 1,
	}
	
	Plan is to enhance this to:
	extraOffset = {
		left: '100%',
		top: '0%',
	}
	extraOffset = {
		left: '30px',
		top: '100px',
	}
	extraOffset = {
		left: '100% + 2px',
		top: '50% + 20px',
	}
	
*/

const getElOffset = (el, extraOffset = {}) => {
	const box = el.getBoundingClientRect();
	
	const left = box.left + window.pageXOffset - document.documentElement.clientLeft;
	const top = box.top + window.pageYOffset - document.documentElement.clientTop;
	
	const offsetXInPixel = getComputedSizeToPixel({
		cssValue: extraOffset.x ?? '0',
		parent: extraOffset.el || el,
		axis: 'x',
	});
	const offsetYInPixel = getComputedSizeToPixel({
		cssValue: extraOffset.y ?? '0',
		parent: extraOffset.el || el,
		axis: 'y',
	});
	
	const finalX = left + offsetXInPixel;
	const finalY = top + offsetYInPixel;
	
	return {
		x: finalX,
		y: finalY,
	};
};



const scrollToElement = (element, scrollOptions = {}) => {
	const _element = (typeof element === 'string') ? document.querySelector(element) : element;
	if (!_element) return false;

	// window.scroll({
	// 	behavior: 'smooth',
	// 	left: 0,
	// 	top: _element.offsetTop + topOffset,
	// });
	
	const topOffset = scrollOptions.topOffset ?? 0;
	
	window.scrollTo({
		behavior: 'smooth',
		top: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - topOffset,
	});
	
	// _element.scrollIntoView({
	// 	behavior: 'smooth',
	// 	block: 'start',
	// 	inline: 'nearest',
	// 	...scrollOptions,
	// });
};


const getStickyElementsHeight = () => {
	let total = 0;
	const htmlElStyle = window.getComputedStyle(document.documentElement);

	document.querySelectorAll('[data-is-sticky]').forEach((node) => {
		const cssVarName = node.getAttribute('data-height-var');
		const cssVarValue = htmlElStyle.getPropertyValue(cssVarName);
		const height = parseFloat(cssVarValue) || 0;
		total += height;
	});
	
	return total;
};


const MHScrollToElement = (element, scrollOptions = {}) => {
	let topOffset = getStickyElementsHeight();
	
	scrollToElement(element, {
		topOffset: topOffset + (scrollOptions.additionalTopOffset ?? 0),
		...scrollOptions,
	});
};


/*
	* Check if an element is out of the viewport
	* (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
	* @param  {Node}    elem The element to check
	* @return {Object}  A set of booleans for each side of the element
*/
const isElOutOfViewport = function (el) {
	// Get element's bounding
	const bounding = el.getBoundingClientRect();

	// Check if it's out of the viewport on each side
	let out = {};
	out.top = bounding.top < 0;
	out.left = bounding.left < 0;
	out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
	out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
	out.any = out.top || out.left || out.bottom || out.right;
	out.all = out.top && out.left && out.bottom && out.right;
	return out;
};

/* Similar to jQuery.parents() */
const getAncestorBySelector = (_el, selector) => {
	const parents = [];
	let el = _el;
	while (el && el !== document) {
		if (!selector || el.matches(selector)) parents.unshift(el);
		el = el.parentNode;
	}
	return parents;
};

// Similar to jQuery.ready() when state = 'interactive'. Similar to jQuery(window).load() when state = 'complete'.
const waitForDocumentReadyState = (state = 'complete') => {
	return new Promise((resolve, reject) => {
		switch (state) {
			case 'complete': {
				if (document.readyState === 'complete') {
					resolve();
					return;
				}
				break;
			}
			case 'interactive': {
				if (
					document.readyState === 'interactive' ||
					document.readyState === 'complete'
				) {
					resolve();
					return;
				}
				break;
			}
			case 'loading': {
				if (
					document.readyState === 'loading' ||
					document.readyState === 'interactive' ||
					document.readyState === 'complete'
				) {
					resolve();
					return;
				}
				break;
			}
			default: {
				console.warn(`waitForDocumentReadyState(). Unknown state "${state}".`);
				reject(new Error(`waitForDocumentReadyState(). Unknown state "${state}".`));
				return;
			}
		}
		const callback = (event) => {
			if (document.readyState === state) {
				resolve();
				document.removeEventListener('readystatechange', callback);
			}
		};
		document.addEventListener('readystatechange', callback);
	});
};

const getElDimensions = (el) => {
	if (!el) return null;
	const computedStyle = getComputedStyle(el);

	const width = el.clientWidth; // width with padding
	const height = el.clientHeight; // height with padding

	const heightWithoutPadding = height - (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom));
	const widthWithoutPadding = width - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight));
	
	return {
		width,
		height,
		heightWithoutPadding,
		widthWithoutPadding,
	};
};

export {
	getElOffset,
	getComputedSizeToPixel,
	scrollToElement,
	MHScrollToElement,
	getStickyElementsHeight,
	isElOutOfViewport,
	getAncestorBySelector,
	waitForDocumentReadyState,
	getElDimensions,
};

